/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721, ERC721Interface } from "../ERC721";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721__factory extends ContractFactory {
  constructor(...args: ERC721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC721";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721> {
    return super.deploy(overrides || {}) as Promise<ERC721>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ERC721 {
    return super.attach(address) as ERC721;
  }
  connect(signer: Signer): ERC721__factory {
    return super.connect(signer) as ERC721__factory;
  }
  static readonly contractName: "ERC721";
  public readonly contractName: "ERC721";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721Interface {
    return new utils.Interface(_abi) as ERC721Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC721 {
    return new Contract(address, _abi, signerOrProvider) as ERC721;
  }
}
